// __webpack_public_path__ needs to be set in own file
// see https://github.com/webpack/webpack/issues/2776

// eslint-disable-next-line camelcase
__webpack_public_path__ = window.__internal.publicPath;
